import Alert from '@oneappexchange/appx-design-system/modules/ax/alert/alert';
import Badge from '@oneappexchange/appx-design-system/modules/ax/badge/badge';
import Bar from '@oneappexchange/appx-design-system/modules/ax/bar/bar';
import Button from '@oneappexchange/appx-design-system/modules/ax/button/button';
import Card from '@oneappexchange/appx-design-system/modules/ax/card/card';
import Chip from '@oneappexchange/appx-design-system/modules/ax/chip/chip';
import Icon from '@oneappexchange/appx-design-system/modules/ax/icon/icon';
import Image from '@oneappexchange/appx-design-system/modules/ax/image/image';
import Tag from '@oneappexchange/appx-design-system/modules/ax/tag/tag';

customElements.define('cms-alert', Alert.CustomElementConstructor);
customElements.define('cms-badge', Badge.CustomElementConstructor);
customElements.define('cms-bar', Bar.CustomElementConstructor);
// Used for the WP Block Editor only. No analytics instrumentation. (Analytics insturmentation is handled by the AceButton component - see cmsElementsDynamic)
customElements.define('cms-wp-button', Button.CustomElementConstructor);
customElements.define('cms-card', Card.CustomElementConstructor);
customElements.define('cms-chip', Chip.CustomElementConstructor);
customElements.define('cms-icon', Icon.CustomElementConstructor);
customElements.define('cms-image', Image.CustomElementConstructor);
customElements.define('cms-tag', Tag.CustomElementConstructor);
